// Client-safe identifiers for the «صدمات الطفولة» courses. No content here.
export const TRAUMA_COURSE_IDS = [
  "rejection",
  "emotional-neglect",
  "fear-safety",
  "comparison",
  "conditional-love",
  "control",
  "betrayal",
  "shame",
  "loss-separation",
  "unpredictability",
  "parentification",
  "emotional-invalidation",
] as const;

export type TraumaCourseId = (typeof TRAUMA_COURSE_IDS)[number];

export function isTraumaCourseId(value: unknown): value is TraumaCourseId {
  return typeof value === "string" && (TRAUMA_COURSE_IDS as readonly string[]).includes(value);
}

export const TRAUMA_CONTENT_VERSION = "1.0";
